import { render, staticRenderFns } from "./GeneralSettingsQuoteAllowedCustomerGroups.vue?vue&type=template&id=77ae0990&"
import script from "./GeneralSettingsQuoteAllowedCustomerGroups.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsQuoteAllowedCustomerGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports